import { all } from 'redux-saga/effects';
import checkoutSagas from 'pages/checkout-braintree/state/sagas';
import wellbeingFeedSagas from 'state/wellbeing-feed/sagas';

export default function* rootSagas(): Iterable<any> {
  yield all([checkoutSagas(), wellbeingFeedSagas()]);
}
